import gql from 'graphql-tag';
import { isUndefined } from 'lodash';
import { getGraphQLClientForSkuAnalysisWithToken } from 'utils/apiRequests';

const skuCategoryQuery = (
	request,
	columns,
	filterForData,
	supplierCount,
	dateRange
) => {
	const { dateFrom, dateTo } = dateRange;
	let { supplier_count, ...filterModelWithoutCount } = filterForData;
	filterModelWithoutCount.pO_Date = {
		operator: 'AND',
		filterType: 'date',
		condition1: {
			filterType: 'date',
			type: 'greaterThanOrEqual',
			dateFrom: dateFrom.split('T')[0],
		},
		condition2: {
			filterType: 'date',
			type: 'lessThanOrEqual',
			dateFrom: dateTo.split('T')[0],
		},
	};
	const fields = columns.map(col => col.field);
	const count = isUndefined(supplier_count)
		? 0
		: Math.max(...supplierCount.values);
	const sortColumn =
		request.sortModel.length > 0
			? [...request.sortModel]
			: [{ colId: '4', sort: 'DESC' }];
	return {
		query: gql`
			query getSKUData(
				$start: Int!
				$end: Int!
				$cteModel:[CTEModelType]
				$cteExist:Boolean
				$sorting: [SortModelType!]
				$filterModel: [FilterModelTypeV2!]
				$rowGroups:[RowGroupModelType!]
		  		$groupCols:[GroupColsModelType!]
		  		$havingModel:[HavingModelType!]
				$valueCols:[ValueColsModelType!]
				$joinModel: [JoinModelType!]
				$caseModel:[CaseModelType!]
				$primaryTable: String!
				$groupKeys:[String!]
			) {
				getSKUData(
					startRow: $start
					endRow: $end
					sorting: $sorting
					cteModel:$cteModel
					cteExist:$cteExist
					filterModel: $filterModel
					rowGroups: $rowGroups
					groupCols: $groupCols
					havingModel: $havingModel
					valueCols: $valueCols
					joinModel: $joinModel
					primaryTable: $primaryTable
					caseModel:$caseModel
					groupKeys:$groupKeys
				) {
					${[...fields]}
				}
			}
		`,
		variables: {
			start: request.startRow,
			end: request.endRow,
			cteExist: true,
			cteModel: [
				{
					cteName: 'SKU_CTE',
					filterModel: [filterModelWithoutCount],
					sorting: [],
					cteTable: '[sxr].[SKU_Analysis] a',
					rowGroups: [
						{ id: '1', displayName: 'sKU', field: 'sKU', selector: 'a' },
					],
					caseModel: [],

					valueCols: [
						{
							id: '1',
							aggFunc: 'MAX',
							displayName: 'pO_DATE',
							field: 'pO_DATE',
							selector: 'a',
							alias: 'maxPODate',
						},
						{
							id: '2',
							aggFunc: 'COUNT',
							displayName: 'Distinct Supplier',
							field: 'distinct Supplier',
							selector: 'a',
							alias: 'distinct_Count_of_Supplier',
						},
						{
							id: '3',
							aggFunc: 'COUNT',
							displayName: 'Distinct Origin_Country',
							field: 'distinct Origin_Country',
							selector: 'a',
							alias: 'distinct_Count_of_Origin_Country',
						},
						{
							id: '4',
							aggFunc: 'sum',
							displayName: 'Total_Spend',
							field: 'total_Spend',
							selector: 'a',
							alias: 'sum_of_Total_Spend',
						},
						{
							id: '5',
							aggFunc: 'sum',
							displayName: 'volume',
							field: 'volume',
							selector: 'a',
							alias: ' sum_of_Volume',
						},
					],
					joinModel: [],
					havingModel: [
						{
							id: '1',
							aggFunc: 'count',
							displayName: 'Distinct Supplier',
							field: 'distinct Supplier',
							type: 'greaterThan',
							value: count.toString(),
							filterType: 'greaterThan',
						},
					],
					groupCols: [
						{ id: '1', displayName: 'sKU', field: 'sKU', selector: 'a' },
					],
					groupKeys: [],
				},
				{
					cteName: 'LPP_CTE',
					filterModel: [filterModelWithoutCount],
					sorting: [],
					cteTable: '[sxr].[SKU_Analysis] b',
					rowGroups: [
						{ id: '1', displayName: 'sKU', field: 'sKU', selector: 'b' },
						{
							id: '2',
							displayName: 'po_Date',
							field: 'po_Date',
							selector: 'b',
						},
						{
							id: '3',
							displayName: 'unit_Price_USD',
							field: 'unit_Price_USD',
							selector: 'b',
						},
					],
					caseModel: [],
					valueCols: [
						{
							id: '1',
							aggFunc: 'ROW_NUMBER() OVER',
							displayName: 'PARTITION BY SKU ORDER BY PO_DATE DESC',
							field: 'PARTITION BY SKU ORDER BY PO_DATE DESC',
							selector: 'b',
							alias: 'rn',
						},
					],
					joinModel: [],
					havingModel: [],
					groupCols: [],
					groupKeys: [],
				},
			],
			primaryTable: 'SKU_CTE s1',
			sorting: sortColumn,
			rowGroups: [
				{ id: '1', displayName: 'sKU', field: 'sKU', selector: 's1' },
				{
					id: '5',
					displayName: 'distinct_Count_of_supplier',
					field: 'distinct_Count_of_Supplier',
					selector: 's1',
				},
				{
					id: '6',
					displayName: 'distinct_Count_of_Origin_Country',
					field: 'distinct_Count_of_Origin_Country',
					selector: 's1',
				},
				{
					id: '7',
					displayName: 'sum_of_Total_Spend',
					field: 'sum_of_Total_Spend',
					selector: 's1',
				},
				{
					id: '8',
					displayName: 'sum_of_Volume',
					field: 'sum_of_Volume',
					selector: 's1',
				},
				{
					id: '9',
					displayName: 'unit_Price_USD',
					field: 'unit_Price_USD as lPP',
					selector: 's2',
				},
				{
					id: '10',
					displayName: 'maxPODATE',
					field: 'maxPODate',
					selector: 's1',
				},
			],
			caseModel: [
				{
					whenCondition: 'S1.sum_of_Volume <> 0',
					thenCondition: 'S1.sum_of_Total_Spend / S1.sum_of_Volume',
					elseCondition: 'null',
					caseName: 'wt_Avg_Price',
				},
			],
			valueCols: [],
			joinModel: [
				{
					tableName: 'LPP_CTE AS s2',
					condition:
						's1.sKU = s2.sKU AND s1.maxPODate = s2.pO_DATE AND s2.rn =1',
					joinType: 'Left JOIN',
				},
			],
			filterModel: [{}],
			havingModel: [],
			groupCols: [],
			groupKeys: [],
		},
	};
};

//this function makes columns from the data
const ServerSideDataSource = gridOptions => {
	return {
		// called by the grid when more rows are required
		getRows: async params => {
			const object = {};
			object.gridOptions = gridOptions;
			object.client = await getGraphQLClientForSkuAnalysisWithToken();
			const columns = object.gridOptions.columnDefs.slice(0, 7);
			const filterForData = gridOptions.skuCteFilterModel;
			const dateRange = gridOptions.dateRange;
			const supplierCount = filterForData.supplier_count;
			object.client
				.query(
					skuCategoryQuery(
						params.request,
						columns,
						filterForData,
						supplierCount,
						dateRange
					)
				)
				.then(response => {
					let rows = response.data.getSKUData;
					let lastRow = -1;
					if (rows.length <= gridOptions.cacheBlockSize) {
						lastRow = params.request.startRow + rows.length;
					}
					params.successCallback(rows, lastRow);
				})
				.catch(err => {
					console.error(err);
					params.failCallback();
				});
		},
	};
};

export default ServerSideDataSource;
